var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 1.9375H8.75C7.64688 1.9375 6.75 2.83438 6.75 3.9375V27.9375C6.75 29.0406 7.64688 29.9375 8.75 29.9375H23.25C24.3531 29.9375 25.25 29.0406 25.25 27.9375V3.9375C25.25 2.83438 24.3531 1.9375 23.25 1.9375ZM16 25.75C15.3094 25.75 14.75 25.1906 14.75 24.5C14.75 23.8094 15.3094 23.25 16 23.25C16.6906 23.25 17.25 23.8094 17.25 24.5C17.25 25.1906 16.6906 25.75 16 25.75Z",
    fill: "#3E4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPhone);
export default __webpack_public_path__ + "static/media/custom_phone.3fa0ea5e0c3ce81fdb5db63bd4f93ad6.svg";
export { ForwardRef as ReactComponent };